import axios from "axios";

const clienteAxios = axios.create({
    baseURL : "https://backsms.neitor.com/"
})
export default clienteAxios